<template>
  <div class="pt-12 p-5 sm:p-12">
    <h1 class="text-center font-serif text-4xl mb-1">Congratulations! 🎉</h1>
    <p class="text-center text-xl text-gray-600">Your digitized memories are now permanently stored in your FOREVER<sub class="reg-mark">®</sub> Account. </p>

    <digitization-completed-project-preview
      :project="project"
      class="mx-auto max-w-md my-6"
    />

    <digitization-status-secondary-text
      center
      font-size-class="text-xl"
      :project="project"
    />

    <template v-if="!currentUser.can?.transcodeVideo && streamingTimeLeft">
      <p class="font-semibold text-center leading-none">Your digitized videos are streamable in your FOREVER Account until {{$dayjs(streamingEnd).format('l')}}!</p>
      <p class="text-center text-gray-500">Longer term <a href="#" class="text-gray-600" @click.prevent="openVideoUpsellModal({context: VIDEO_UPSELL_CONTEXTS.digitizationProjectMadePermanent})">streaming & editing plans</a> are available for purchase.</p>
    </template>

  </div>
</template>

<script setup>
  const {openVideoUpsellModal} = useCommonModals();
  const ss = useSessionStore();
  const {currentUser} = storeToRefs(ss);

  const props = defineProps({
    project: Object
  });

  const streamingEnd = computed(() => {
    const baseMs = 90 * 24 * 60 * 60 * 1000; // 90 days in ms
    const saved = new Date(props.project.made_permanent_at).getTime();
    const expires = new Date(props.project.download_expires_at).getTime();
    const leftover = Math.max(expires - saved, 0);

    return new Date(saved + baseMs + leftover);
  });

  const streamingTimeLeft = computed(() => {
    const now = Date.now();
    const msLeft = streamingEnd.value.getTime() - now;
    return Math.max(Math.ceil(msLeft / (1000 * 60 * 60 * 24)), 0);
  })

  onMounted(() => {
    useConfetti().fireworks({duration: 2500});
  })
</script>
